<template>
  <ol class="onboarding-steps list-unstyled d-flex align-items-center mb-0">
    <li
      v-for="(step, index) in STEPS"
      :key="step"
      class="onboarding-step d-flex align-items-center"
      :class="{
        'is-done': index < currentIndex,
        'is-current': index === currentIndex,
      }"
      :aria-current="index === currentIndex ? 'step' : undefined"
    >
      <span class="step-marker">
        <FontAwesomeIcon v-if="index < currentIndex" icon="check" />
        <template v-else>{{ index + 1 }}</template>
      </span>
      <span class="step-label">{{ $t(`billing.steps.${step}`) }}</span>
      <span
        v-if="index < STEPS.length - 1"
        class="step-line"
        aria-hidden="true"
      ></span>
    </li>
  </ol>
</template>

<script setup lang="ts">
/** The corporate onboarding progress: company details (signup), then needs, agreement and plan (dashboard modal). */
import { computed } from "vue";

const STEPS = ["company", "needs", "agreement", "plan"] as const;

const props = defineProps<{
  current: (typeof STEPS)[number];
}>();

const currentIndex = computed(() => STEPS.indexOf(props.current));
</script>

<style scoped lang="scss">
.onboarding-step {
  gap: 0.5rem;
  font-size: 0.85rem;
  color: var(--phoenix-secondary-color);

  &:not(:last-child) {
    flex: 1 1 auto;
  }
}

.step-marker {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: 1.75rem;
  height: 1.75rem;
  border-radius: 50%;
  font-weight: 700;
  font-size: 0.8rem;
  border: 2px solid var(--phoenix-border-color);
  background: var(--phoenix-body-bg);
}

.step-line {
  flex: 1 1 auto;
  min-width: 1rem;
  height: 2px;
  margin: 0 0.5rem;
  background: var(--phoenix-border-color);
}

.is-done {
  .step-marker {
    border-color: var(--phoenix-success);
    background: var(--phoenix-success);
    color: #fff;
  }

  .step-line {
    background: var(--phoenix-success);
  }
}

.is-current {
  color: var(--phoenix-emphasis-color);
  font-weight: 600;

  .step-marker {
    border-color: var(--phoenix-primary);
    color: var(--phoenix-primary);
  }
}

@media (max-width: 575.98px) {
  .step-label {
    display: none;
  }
}
</style>
